import {
  initialState,
  Actions,
  State,
  DELETE_POST,
  DELETE_POST_SUCCESS,
  DELETE_POST_ERROR,
  RESET_DELETE_POST,
} from "../../types/post/delete-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_POST:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case DELETE_POST_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case DELETE_POST_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_DELETE_POST:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
